import { fork, all } from 'redux-saga/effects';
import { watchApiTask } from 'app/sagas';
import { api } from 'app/api';
import * as actions from './reportGeneralPanelTRIActions';

export const getESFilterTRITask = watchApiTask(
  actions.GET_ES_FILTER_TRI,
  api.post,
  'ES-TRI/getESFilterTRI.php',
);

export const getESTRIDetailTask = watchApiTask(
  actions.GET_ES_TRI_DETAIL,
  api.post,
  'ES-TRI/getESTRIDetail.php',
);

export const getESReportTRITask = watchApiTask(
  actions.GET_ES_REPORT_TRI,
  api.post,
  'ES-TRI/getESReportTRI.php',
);

export const generateReportTRITask = watchApiTask(
  actions.GENERATE_REPORT_TRI,
  api.post,
  'ES-TRI/generateReportTRI.php',
);
export const geQuestionDetailTRITask = watchApiTask(
  actions.GET_ES_QUESTION_DETAIL_TRI,
  api.post,
  'ES-TRI/getQuestionsDetailTRI.php',
);

export const getESTRIStudentDetailTask = watchApiTask(
  actions.GET_ES_TRI_STUDENT_DETAIL,
  api.post,
  'ES-TRI/getESTRIStudentDetail.php',
);

export const getESStudentReportTRITask = watchApiTask(
  actions.GET_ES_STUDENT_REPORT_TRI,
  api.post,
  'ES-TRI/getESStudentReportTRI.php',
);

export const getESEvaluationsCicleStudentTRITask = watchApiTask(
  actions.GET_ES_EVALUATIONS_CICLE_STUDENT_TRI,
  api.post,
  'ES-TRI/getESEvaluationsCicleStudentTRI.php',
);

export const getESSchoolReportTRITask = watchApiTask(
  actions.GET_ES_SCHOOL_REPORT_TRI,
  api.post,
  'ES-TRI/getESSchoolReportTRI.php',
);
export const generateSchoolReportTRITask = watchApiTask(
  actions.GENERATE_SCHOOL_REPORT_TRI,
  api.post,
  'ES-TRI/generateSchoolReportTRI.php',
);
export const getESTRISchoolDetailTask = watchApiTask(
  actions.GET_ES_TRI_SCHOOL_DETAIL,
  api.post,
  'ES-TRI/getESTRISchoolDetail.php',
);

export const getESApplicationReportTRITask = watchApiTask(
  actions.GET_ES_APPLICATION_REPORT_TRI,
  api.post,
  'ES-TRI/getESApplicationReportTRI.php',
);

export const getESTRIApplicationDetailTask = watchApiTask(
  actions.GET_ES_TRI_APPLICATION_DETAIL,
  api.post,
  'ES-TRI/getESTRIApplicationDetail.php',
);

// Root module saga
export function* sagas() {
  yield all([
    fork(getESFilterTRITask),
    fork(getESTRIDetailTask),
    fork(getESReportTRITask),
    fork(generateReportTRITask),
    fork(getESTRIStudentDetailTask),
    fork(getESStudentReportTRITask),
    fork(getESEvaluationsCicleStudentTRITask),
    fork(geQuestionDetailTRITask),
    fork(getESSchoolReportTRITask),
    fork(generateSchoolReportTRITask),
    fork(getESTRISchoolDetailTask),
    fork(getESApplicationReportTRITask),
    fork(getESTRIApplicationDetailTask),
  ]);
}
